'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _components = require('./components');
var _arrowIconIdentifier = require('./helpers/arrowIconIdentifier');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getGallerySwiperParams = function getGallerySwiperParams(_ref) {var isMobile = _ref.isMobile,isRtl = _ref.isRtl,className = _ref.className,_ref$title = _ref.title,title = _ref$title === undefined ? {} : _ref$title;
  var arrowProps = {
    className: className,
    isMobile: isMobile };var _title$prevParams =


  title.prevParams,prevParams = _title$prevParams === undefined ? '' : _title$prevParams,_title$nextParams = title.nextParams,nextParams = _title$nextParams === undefined ? '' : _title$nextParams;

  return {
    spaceBetween: 10,
    navigation: {
      nextEl: (0, _arrowIconIdentifier.getNextIcon)(isMobile, isRtl),
      prevEl: (0, _arrowIconIdentifier.getPrevIcon)(isMobile, isRtl),
      disabledClass: 'disabled-arrow' },

    renderCustomPrevButton: function renderCustomPrevButton() {return (
        _react2.default.createElement(_components.GalleryArrow, _extends({
          position: isRtl ? 'right' : 'left',
          title: prevParams },
        arrowProps)));},


    renderCustomNextButton: function renderCustomNextButton() {return (
        _react2.default.createElement(_components.GalleryArrow, _extends({
          position: isRtl ? 'left' : 'right',
          title: nextParams },
        arrowProps)));} };



};exports.default =

getGallerySwiperParams;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/galleryParams.js
// module id = 387
// module chunks = 0